<template>
  <div class="CurrentTemperatures">
    
    <div v-for="data in datas" v-bind:key="data.sensor">
      
        <div class="columns">
            <div class="column is-10">  
                <div class="field-label is-small">
                    <label class="label is-left">{{data.sensor}}. {{data.title}} </label>
                </div>
            </div>
            <div class="column">  
                
              <input class="input is-small" type="text" placeholder="" :value="data.value">
                        
            </div>
        </div>
       
    </div>
    
   
  </div>
</template>

<script>



export default {
  name: 'CurrentTemperatures',
  props: {
    data: Object,
    
  },
  data() {
    return {
      datas: [
          {sensor: 1, value: 0, title: "CWU"},
          {sensor: 2, value: 0, title: "CWU - cyrkulacja"},
          {sensor: 3, value: 0, title: "CO – zasilanie"},
          {sensor: 4, value: 0, title: "CO – powrót"},
          {sensor: 5, value: 0, title: "Kotły"},
      ]
    }
  },
  mounted () {
    var objData = {
       id: this.data.id,
    
    }
    
    this.$store.dispatch('getLast', objData)
    .then(response => {
      //console.log("getLast2")
      //console.log(response.data[0])
      this.buildForm(response.data[0])
    })
    .catch(error => {
        console.log(error)
        return error
    });
    
    
  },
  methods: {
    buildForm(_data){
      //console.log(_data)
      for (var i = 0, lei = this.datas.length; i < lei; i++){
        if (i == 0){
          this.datas[i].value = _data.t1;          
        }
        if (i == 1){
          this.datas[i].value = _data.t2;          
        }
        if (i == 2){
          this.datas[i].value = _data.t3;          
        }
        if (i == 3){
          this.datas[i].value = _data.t4;          
        }
        if (i == 4){
          this.datas[i].value = _data.t5;          
        }
        
      }
    }
  }
}
</script>

<style scoped>
  .CurrentTemperatures input{
      width: 50px;
      
  }
  .field-label .label {
    font-family: Tahoma;
  }
  .CurrentTemperatures .label{
      font-weight: normal;
      
  } 
  .CurrentTemperatures .column{
      padding: 5px;
      
  } 
  .card .card-content{
    background-color: #333 !important;
  }
  .card .card-footer{
    background-color: #333 !important;
  }
</style>
